

export default function getProducts(room, austattung_produkt){

    const productList = [];
    const schaltbare = [];
    const normal = [];

    if(
        room.selectedEquipment["steckdosen"] !== undefined
        && room.selectedEquipment["steckdosen"] > 0
        && austattung_produkt["steckdosen"] !== undefined
    ){
        productList.push({
            product: austattung_produkt["steckdosen"],
            count: room.selectedEquipment["steckdosen"]
        })
        for (let i = 0; i<room.selectedEquipment["steckdosen"];i++) {
            normal.push(austattung_produkt["steckdosen"]);
        }
    }
    return { productList, schaltbare, normal };
}
